import React from "react";
import MenuItem from "./menuItem";
import MenuIds from "./MenuIds";
import MegaMenuTemplate from "../megaMenu/megaMenuTemplate";

export interface IDepthTestMenuProps {
  pushMenuStack: (
    id: string | undefined,
    label: string | undefined,
    icon: string | undefined,
    svg: (() => React.ReactNode) | undefined,
    src: string | undefined,
    href: string | undefined,
    subMenuUseHref: boolean | undefined,
    linkClass: string | undefined,
    extras: unknown | undefined
  ) => void;
}

function DepthTestMenu(props: IDepthTestMenuProps) {
  return (
    <div>
      <MenuItem
        label="Another Sub Menu"
        menuId={MenuIds.DEPTH_TEST_MENU}
        pushMenuStack={props.pushMenuStack}
      />
      <MegaMenuTemplate mobile />
    </div>
  );
}

export default DepthTestMenu;
